import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';

type TAvailability = {
  status: TProductDetail['status'];
};

const Availability: FunctionComponent<TAvailability> = ({ status }) => {
  const { t } = useTranslation();
  return (
    <div
      className={cx(
        { 'bg-green-100': status === 'STO' },
        { 'bg-red-100': status === 'SOL' },
        { 'bg-orange-100': status === 'RSV' },
        'p-1',
        'text-xs',
        { 'text-white': status !== 'RSV' },
        'font-bold',
        'rounded-sm'
      )}
    >
      {t(`product:availability.${status}`)}
    </div>
  );
};

export default Availability;
